var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.3322 4.70531L11.499 8.17078L13.3301 11.5574C13.4159 11.7172 13.4131 11.9101 13.3212 12.0671C13.2292 12.2234 13.0625 12.3202 12.8806 12.323L3.66318 12.4468V4.46326C3.66318 4.1768 3.43098 3.94458 3.14453 3.94458H12.8737C13.0556 3.94458 13.2243 4.03933 13.3184 4.19562C13.4124 4.35192 13.4173 4.54486 13.3322 4.70531Z",
    fill: "#1080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9564 3.94287C3.26672 3.94287 3.51828 4.11704 3.51828 4.33188V13.6681C3.51828 13.8829 3.26672 14.0571 2.9564 14.0571C2.64609 14.0571 2.39453 13.8829 2.39453 13.6681V4.33188C2.39453 4.11704 2.64609 3.94287 2.9564 3.94287Z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.49f126144cf2e2a770dba94447bd733e.svg";
export { ForwardRef as ReactComponent };